// Centralized site data — copy, dishes, events, testimonials
export const BUSINESS = {
  name: "Ateng K Sarap",
  tagline: "Pinoy Fusion Catering Services",
  phone: "619-962-8969",
  phoneLink: "tel:+16199628969",
  email: "Atengksarap@gmail.com",
  emailLink: "mailto:Atengksarap@gmail.com",
  address: "2707 Boston Avenue, San Diego, CA 92113",
  mapEmbed:
    "https://www.google.com/maps?q=2707+Boston+Avenue+San+Diego+CA+92113&output=embed",
  hero: "Bringing the Heart of Filipino Cuisine to San Diego, California – Authentic, Flavorful, and Made with Love.",
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_79e60aa8-f564-428c-950a-4b3ac51325a4/artifacts/dezu6703_Ateng-K-Logo-transparent-150x150.png";

export const HERO_IMAGE = "/images/hero-food.webp";
export const EVENT_FOOD_IMAGE = "/images/event-food.webp";
export const CATERING_SPREAD_IMAGE = "/images/catering-spread.webp";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/gallery", label: "Gallery" },
  { to: "/menu", label: "Menu" },
  { to: "/catering", label: "Catering Events" },
  { to: "/opportunity", label: "Opportunity" },
  { to: "/contact", label: "Contact Us" },
];

// Optimized Unsplash URLs — WebP, quality 70, sized appropriately
const uns = (id, w = 1000) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=70&fm=webp`;

export const FEATURED_DISHES = [
  {
    name: "Pansit / Pasta",
    tagline: "Rice noodles garnished with veggies.",
    description:
      "A celebration staple — silky rice noodles tossed with seasonal vegetables, savory broth, and Filipino-style aromatics. Symbol of long life and gathering.",
    image: "/images/pansit.webp",
    accent: "secondary",
  },
  {
    name: "Belly Lechon",
    tagline: "Pork belly grilled to golden perfection.",
    description:
      "Slow-roasted pork belly with shatter-crisp skin and tender, herb-kissed meat. The centerpiece every Filipino celebration deserves.",
    image: "/images/lechon.webp",
    accent: "accent",
  },
  {
    name: "Pork Shanghai",
    tagline: "Fried wrapped ground pork & veggies.",
    description:
      "Hand-rolled lumpia Shanghai — crisp golden wrappers hugging seasoned pork and vegetables. The first to disappear at every table.",
    image: uns("photo-1606755962773-d324e0a13086", 900),
    accent: "secondary",
  },
  {
    name: "Kare-Kare",
    tagline: "Beef in peanut & shrimp paste.",
    description:
      "A rich, velvety peanut stew with tender beef and vegetables, traditionally served with bagoong. Heritage on a plate.",
    image: "/images/kare-kare.webp",
    accent: "primary",
  },
  {
    name: "Beef Apritada",
    tagline: "Sautéed beef with mild spicy sauce.",
    description:
      "Slow-braised beef in a tomato-pepper sauce with potatoes and bell peppers. Comfort, plated warmly.",
    image: uns("photo-1604908176997-125f25cc6f3d", 900),
    accent: "primary",
  },
  {
    name: "Chop Suey",
    tagline: "Sautéed vegetables with quail eggs.",
    description:
      "A medley of stir-fried garden vegetables and delicate quail eggs in a light savory glaze. Fresh, bright, and beautifully Filipino.",
    image: uns("photo-1512058564366-18510be2db19", 900),
    accent: "accent",
  },
];

export const EVENTS = [
  {
    title: "Weddings",
    blurb: "Heartfelt menus and elegant service for the most important day.",
    image: uns("photo-1519671482749-fd09be7ccebf", 1100),
  },
  {
    title: "Birthdays",
    blurb: "Make every year a feast — from intimate dinners to grand parties.",
    image: uns("photo-1530103862676-de8c9debad1d", 1100),
  },
  {
    title: "Corporate Events",
    blurb: "Polished catering for offsites, launches, and team celebrations.",
    image: uns("photo-1511795409834-ef04bbd61622", 1100),
  },
  {
    title: "Graduations",
    blurb: "Celebrate the milestone with food that tastes like home.",
    image: uns("photo-1523580494863-6f3031224c94", 1100),
  },
  {
    title: "Family Gatherings",
    blurb: "Boodle-style spreads built for laughter and second helpings.",
    image: "/images/catering-spread.webp",
  },
  {
    title: "Community Celebrations",
    blurb: "Block parties, fundraisers, fiestas — we cater warmly at scale.",
    image: uns("photo-1555244162-803834f70033", 1100),
  },
];

export const TESTIMONIALS = [
  {
    name: "Marisol R.",
    role: "Wedding Client, La Mesa",
    quote:
      "Ateng K Sarap turned our wedding into a true Filipino celebration. The lechon belly had every guest asking for the recipe. Heartfelt, professional, unforgettable.",
  },
  {
    name: "Jordan T.",
    role: "Corporate Event, Downtown SD",
    quote:
      "We hired Ateng for a 120-person quarterly. Setup was seamless, the team was warm, and the kare-kare was the talk of the office for weeks.",
  },
  {
    name: "Liza M.",
    role: "70th Birthday Party",
    quote:
      "Mom cried happy tears. The pansit, the lumpia, the lechon — it tasted like Manila. Thank you for bringing home to our table.",
  },
  {
    name: "Aaron P.",
    role: "Graduation Celebration",
    quote:
      "Tailored exactly to our budget without compromising flavor. Ateng K Sarap is now our family caterer for every milestone.",
  },
];

export const MENU = {
  Appetizers: [
    { name: "Lumpia Shanghai", desc: "Crisp pork & vegetable spring rolls with sweet chili." },
    { name: "Lumpia Sariwa", desc: "Fresh vegetable lumpia with peanut-garlic sauce." },
    { name: "Chicken Empanada", desc: "Flaky pastry filled with savory chicken and raisins." },
    { name: "Cheese Sticks", desc: "Golden-fried with sweet chili dip — a fiesta classic." },
  ],
  "Main Dishes": [
    { name: "Belly Lechon", desc: "Slow-roasted pork belly with crackling skin.", featured: true },
    { name: "Kare-Kare", desc: "Beef in peanut & shrimp paste with vegetables.", featured: true },
    { name: "Beef Apritada", desc: "Sautéed beef in mild tomato-pepper sauce.", featured: true },
    { name: "Chicken Adobo", desc: "Soy-vinegar braised chicken — the national favorite." },
    { name: "Sinigang na Baboy", desc: "Tamarind pork soup with garden vegetables." },
    { name: "Bistek Tagalog", desc: "Citrus-soy beef steak with sweet onions." },
  ],
  "Noodles & Rice": [
    { name: "Pansit / Pasta", desc: "Rice noodles garnished with veggies.", featured: true },
    { name: "Pansit Palabok", desc: "Rice noodles in rich shrimp sauce, egg, and chicharrón." },
    { name: "Pansit Canton", desc: "Stir-fried egg noodles with chicken, shrimp, vegetables." },
    { name: "Garlic Fried Rice", desc: "Fragrant sinangág — the Filipino breakfast staple." },
    { name: "Java Rice", desc: "Golden turmeric-tomato rice — vibrant and aromatic." },
  ],
  "Party Trays": [
    { name: "Pansit Tray (serves 15-20)", desc: "Rice noodles with vegetables and protein." },
    { name: "Lumpia Shanghai Tray (50 pcs)", desc: "Crisp pork spring rolls — crowd favorite." },
    { name: "Lechon Belly Platter", desc: "Carved pork belly with sauces and pickled sides." },
    { name: "Kare-Kare Tray (serves 12-15)", desc: "Peanut beef stew with vegetables and bagoong." },
    { name: "Chop Suey Tray", desc: "Sautéed vegetables with quail eggs — featured!", featured: true },
  ],
  Desserts: [
    { name: "Leche Flan", desc: "Silky caramel custard — every fiesta's sweet finale." },
    { name: "Bibingka", desc: "Coconut rice cake baked the traditional way." },
    { name: "Cassava Cake", desc: "Rich, chewy cassava with custard topping." },
    { name: "Halo-Halo Bar", desc: "Build-your-own shaved-ice with classic toppings." },
    { name: "Ube Crinkles", desc: "Soft purple yam cookies dusted with sugar." },
  ],
  "Catering Specials": [
    { name: "Fiesta Package", desc: "Belly lechon, pansit, lumpia, rice, and dessert. Tailored to guest count." },
    { name: "Family Boodle Spread", desc: "Banana-leaf style feast — grilled meats, rice, sides." },
    { name: "Corporate Lunch Trays", desc: "Polished sets for offices and meetings." },
    { name: "Custom Menu", desc: "We build a menu around your budget, theme, and family favorites." },
  ],
};

export const GALLERY_IMAGES = [
  "/images/hero-food.webp",
  "/images/event-food.webp",
  "/images/catering-spread.webp",
  "/images/pansit.webp",
  "/images/lechon.webp",
  "/images/kare-kare.webp",
  uns("photo-1606755962773-d324e0a13086", 900),
  uns("photo-1604908176997-125f25cc6f3d", 900),
  uns("photo-1519671482749-fd09be7ccebf", 900),
  uns("photo-1555244162-803834f70033", 900),
  uns("photo-1530103862676-de8c9debad1d", 900),
  uns("photo-1523580494863-6f3031224c94", 900),
];
